export default {
  heroSection: {
    title: {
      fr: "Maison connectée\nnouvelle génération",
      en: "Next-generation smarthome",
    },
    subtitle: {
      fr: "Économie d'énergie. Confort. Sécurité.\nL'intelligence à votre service.",
      en: "Energy savings. Comfort. Security.\nOne size fits all.",
    },
  },
};
